import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import DialogContent from '@material-ui/core/DialogContent';

import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';

import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} direction="up" {...props} />;
});

const useStyles = makeStyles((theme) => ({
  container: {
    backdropFilter: 'blur(5px)'
  },
  header: {
    textAlign: 'center',
    fontSize: 42,
    color: '#132533'
  },
  paper: {
    padding: 30,
    minWidth: 700
  },
  textField: {
    marginTop: '.5rem',
    width: '100%'
  },
  buttonDiv: {
    marginTop: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  send: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    marginRight: 25,
    minWidth: '110px'
  },
  cancel: {
    background: '#6D7278',
    fontFamily: 'PT sans',
    fontSize: '16px',
    color: '#FFF',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    marginLeft: 25,
    minWidth: '110px'
  }
}));

const SendModal = ({ open, onClose }) => {
  const [comments, setComments] = useState('');
  const classes = useStyles();
  return (
    <div>
      <Dialog
        classes={{ paper: classes.paper, container: classes.container }}
        keepMounted
        maxWidth={false}
        onClose={onClose}
        open={open}
        TransitionComponent={Transition}>
        {/* Header */}
        <div className={classes.header}>
          <p>Send my feedback to issuer</p>
        </div>

        <DialogContent>
          <FormControl className={classes.textField} variant="outlined">
            <OutlinedInput
              id="outlined-adornment-valuation"
              inputProps={{
                'aria-label': 'comments'
              }}
              labelWidth={0}
              multiline
              onChange={(e) => setComments(e.target.value)}
              placeholder="comments"
              rows={4}
              rowsMax={4}
              value={comments}
            />
          </FormControl>
        </DialogContent>

        <div className={classes.buttonDiv}>
          <div>
            <Button
              className={classes.cancel}
              onClick={onClose}
              variant="contained">
              cancel
            </Button>
          </div>
          <div>
            <Button
              className={classes.send}
              color="primary"
              onClick={onClose}
              variant="contained">
              send to issuer
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default SendModal;
